import { getDiscountInfo } from '@features/scrollable-basket'

import { useIsBasketInGoustoAnytimeDiscountPopulation } from './useIsBasketInGoustoAnytimeDiscountPopulation'

// The discount payload to attach to the checkout tracking event, or undefined when
// the basket isn't in the discount population. Keeps checkout call sites unaware of
// the experiment — they forward this opaque value into checkoutBasket.
export const useBasketCheckoutDiscount = (pricing: Parameters<typeof getDiscountInfo>[0]) => {
  const isInPopulation = useIsBasketInGoustoAnytimeDiscountPopulation()

  return isInPopulation ? getDiscountInfo(pricing) : undefined
}
